import React, { useEffect } from "react";
import { useNavigate  } from "react-router-dom";
import { foundryLoginOAuth } from "../../service/foundryService";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../store/store";

const OAuthLogin = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
      let params = new URLSearchParams(window.location.search);
      if (params.get("code")) {
        handleFoundryOAuthLogin(params)
      }
    }, []);
    const handleFoundryOAuthLogin = async (params) =>{
        try {
          let data = await foundryLoginOAuth(params)
          let token = data.access_token;
          let timeout = data.expires_in * 1000 + Date.now();
          let typeOfLogin = "FoundryOAuth"
          dispatch(loginSuccess({ token, timeout, typeOfLogin }));
          return navigate("/home")
          
        } catch (error) {
          console.error("401-Unauthorized")
        }
    }
}
export default OAuthLogin;